import { render, staticRenderFns } from "./dadosEvento.vue?vue&type=template&id=b608bb3c"
import script from "./dadosEvento.vue?vue&type=script&lang=js"
export * from "./dadosEvento.vue?vue&type=script&lang=js"
import style0 from "./dadosEvento.vue?vue&type=style&index=0&id=b608bb3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports